export default "__VITE_ASSET__edcb5684__"